import React, { useState } from 'react'
import UserDetails from 'containers/UserDetails'
import { ContainerGeral } from './Styled'

// Componentes
import BannerPrincipal from './Components/BannerPrincipal/BannerPrincipal'
import BonusExclusivos from './Components/BonusExclusivos/BonusExclusivos'
import Planos from './Components/Planos/Planos'

export default function PromocaoJaneiro2026 () {

	return (
		<UserDetails showSpinner>
			{details => {

				const [data] = useState(details.blackfriday)

				let planosInitial = data.planos;

				return (
					<ContainerGeral padding={false}>
						
						{/* Banner Principal */}
						<BannerPrincipal lote={data.lote} planos={planosInitial} desconto={planosInitial[1].assinaturas[0].boleto.desconto_valor} />

						{/* Bônus Exclusivos */}
						{ data.lote !== 4 ? <BonusExclusivos lote={data.lote} /> : null }

						{/* Planos */}
						<Planos planos={planosInitial} lote={data.lote} />
	
					</ContainerGeral>
				)
				
			}}
		</UserDetails>
	)
}
